// Editable site copy blocks with built-in defaults. Overrides live in
// site-settings and apply instantly (no redeploy) via Admin → Homepage Copy.
export const DEFAULT_FREE_ENTRY = {
  title: "Not ready for a package? Here's what a free entry includes.",
  body:
    'Anybody with a free entry gets a basic listing on the website: one photograph, your web link and up to 25 words of text. ' +
    'Phone numbers and email contacts are not published on free entries, and any other services you wish to access are chargeable at our published rates. ' +
    'Want more? Start with the Entry Level package above.',
};

export const mergeFreeEntry = (override) => ({
  title: (override?.title || '').trim() || DEFAULT_FREE_ENTRY.title,
  body: (override?.body || '').trim() || DEFAULT_FREE_ENTRY.body,
});
